<template>
  <div>
    <c-card title="" class="cardClassDetailForm pre-work-check-target">
      <template slot="card-detail">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <c-field
            :disabled="disabled"
            :editable="editable"
            class="preWorkDaliyCheckUser"
            name="userId"
            label="점검자"
            v-model="target.userId">
          </c-field>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <c-upload 
            :attachInfo="attachInfo"
            :editable="editable&&!disabled"
            label="첨부파일">
          </c-upload>
        </div>
      </template>
    </c-card>
    <c-table
      ref="table"
      :title="`${target.checkDate} 일상점검결과`"
      :columns="grid.columns"
      :merge="grid.merge"
      :data="filteringData"
      :editable="editable&&!disabled"
      :filtering="false"
      :columnSetting="false"
      :usePaging="false"
      gridHeightAuto
    >
      <template v-slot:customArea="{ props, col }">
        <component
          v-if="col.name === 'customCol'"
          :is="imprComponent"
          :col="col"
          :props="props"
          :inputEditable="editable&&!disabled"
          :isImmShow="true"
          :requestContentsCols="requestContentsCols"
          tableKey="sopPreWorkCheckTargetResultId"
          ibmTaskTypeCd="ITT0000195"
          ibmTaskUnderTypeCd="ITTU000221"
          @imprChange="imprChange"
        />
      </template>
      <template slot="customFilter">
        <c-radio
          :comboItems="filterItems"
          label=""
          name="filter"
          v-model="filter"
        />
      </template>
      <template slot="table-button">
        <q-btn-group outline>
          <c-btn
            v-if="editable&&!disabled"
            :url="saveUrl"
            :isSubmit="isSave"
            :param="target"
            mappingType="PUT"
            label="저장"
            icon="save"
            @beforeAction="saveInfo"
            @btnCallback="saveInfoCallback" />
        </q-btn-group>
      </template>
    </c-table>
  </div>
</template>
<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'preWorkCheckTargetDayResultAppr',
  props: {
    popupParam: {
      type: Object,
      default(){
        return {
          sopPreWorkCheckTargetId: '',
        }
      },
    },
    contentHeight: {
      type: [String, Number],
      default: function() {
        return 'auto'
      },
    }
  },
  data() {
    return {
      target: {
        sopPreWorkCheckTargetId: '',  // 작업 전 안전점검 대상 일련번호
        sopPreWorkCheckId: '',  // 작업 전 안전점검 일련번호
        pwcPreWorkCheckStepCd: '',
        deptCd: '',  // 점검부서
        deptName: '',  // 점검부서
        userId: '',  // 점검자
        userName: '',  // 점검자
        yearmonth: '',  // 년월
        checkDate: '',  // 점검일
        regUserId: '',  // 등록자 ID
        chgUserId: '',  // 수정자 ID
        results: [],
      },
      grid: {
        merge: [
          { index: 0, colName: 'sopPreWorkCheckClassCd' },
          { index: 1, colName: 'checkItemName' },
        ],
        columns: [
          {
            name: 'sopPreWorkCheckClassName',
            field: 'sopPreWorkCheckClassName',
            label: '점검<br/>구분',
            align: 'center',
            sortable: true,
            style: 'width:50px',
          },
          {
            name: 'checkItemName',
            field: 'checkItemName',
            label: '점검항목명',
            align: 'left',
            sortable: true,
            style: 'width:80px',
          },
          {
            name: 'checkItemSubName',
            field: 'checkItemSubName',
            label: '점검세부항목명',
            align: 'left',
            sortable: true,
            style: 'width:150px',
          },
          {
            required: true,
            name: 'pwcResultCd',
            field: 'pwcResultCd',
            label: '결과',
            align: 'center',
            sortable: false,
            style: 'width:85px',
            type: 'select',
            codeGroupCd: 'PWC_RESULT_CD',
            setHeader: true,
            headType: 'select',
          },
          {
            name: 'addInfo',
            field: 'addInfo',
            label: '부가<br/>정보',
            align: 'left',
            sortable: false,
            style: 'width:70px',
            type: 'text',
            suffixCol: 'unit'
          },
          {
            name: 'customCol',
            field: 'customCol',
            label: '',
            align: 'center',
            style: 'width:30px',
            type: 'custom',
            sortable: false
          },
        ],
        height: '500px'
      },
      attachInfo: {
        isSubmit: '',
        taskClassCd: 'SOP_PRE_WORK_TARGET',
        taskKey: '',
      },
      filter: 'A',
      filterItems: [
        { code: 'A', codeName: '전체보기', },
        { code: 'M', codeName: '할당된 항목 보기', },
      ],
      editable: true,
      isSave: false,
      detailUrl: '',
      saveUrl: '',
    };
  },
  computed: {
    // 개선요청 내용 전달
    requestContentsCols() {
      return ['sopPreWorkCheckClassName', 'checkItemName', 'checkItemSubName'];
    },
    // 개선요청 Component
    imprComponent() {
      return () => import(`${'@/pages/common/ibm/mobileTableImpr.vue'}`);
    },
    filteringData() {
      let items = [];
      if (this.target.results && this.target.results.length > 0) {
        if (this.filter === 'M') {
          // 나에게 할당된 점검항목 filtering
          items = this.$_.filter(this.target.results, (result) => {
            return Boolean(result.userId) && result.userId.indexOf(this.$store.getters.user.userId) > -1
          })
        } else {
          // 전체보기
          items = this.target.results;
        }
      }
      return items;
    },
    disabled() {
      return this.target.pwcPreWorkCheckStepCd === 'PWC000005' 
        // 점검주관부서가 아닌경우 비활성화
        || this.target.deptCd !== this.$store.getters.user.deptCd
    },
  },
  watch: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.detailUrl = selectConfig.sop.pwc.target.getId.url
      this.saveUrl = transactionConfig.sop.pwc.target.update.url
      // code setting
      // list setting
      this.getDetail();
    },
    getDetail() {
      console.log(this.popupParam.sopPreWorkCheckTargetId)
      this.$http.url = this.$format(this.detailUrl, this.popupParam.sopPreWorkCheckTargetId);
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.$_.extend(this.target, _result.data);

        this.$set(this.attachInfo, 'taskKey', this.target.sopPreWorkCheckTargetId)
      },);
    },
    saveInfo() {
      if (this.$comm.validTable(this.grid.columns, this.filteringData)) {
        window.getApp.$emit('CONFIRM', {
          title: 'LBLCONFIRM',
          message: 'MSGSAVE', // 저장하시겠습니까?
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.target.chgUserId = this.$store.getters.user.userId
            
            this.isSave = !this.isSave
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    saveInfoCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getDetail();
    },
    imprChange() {
      this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
    },
  }
};
</script>
<style lang="sass">
.preWorkDaliyCheckUser
  padding-bottom: 0px !important
  .q-field
    padding: 0 !important
</style>